import { BG_SCHEMA, TITLE_SCHEMA, TEXT_SCHEMA, BUTTON_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const CAMPAIGN_ITEM_OPTION = () => ({
  field: '',
  caption: '',
  type: '' // text, email, phone, submit
})

export const CAMPAIGN_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'campaign',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Campanha'),
    text: TEXT_SCHEMA(),
    bg: BG_SCHEMA(),
    buttons: [BUTTON_SCHEMA()],
    token: '',
    'text-position': 'left',
    'text-color': '#202020',
    'layer-color': '#FFFFFF',
    items: [CAMPAIGN_ITEM_OPTION()]
  }
}

export const beforeParseCampaign = target => {
  commonBeforeParseMethod(target, ['bg'])
  if (!target.buttons) Object.assign(target, {buttons: [BUTTON_SCHEMA()]})
}

export const CAMPAIGN_SECTION = config => ({
  schema: CAMPAIGN_SCHEMA(config),
  beforeParse: beforeParseCampaign
})
